var render = function render(){
  var _vm$selectedTransacti, _vm$selectedTransacti2, _vm$selectedTransacti3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "915",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "trans-detail-card"
  }, [_c('v-card-title', [_c('span', [_vm._v(_vm._s(_vm.$t('amazon_transparency_transaction_detail')))])]), _c('div', {
    staticClass: "ma-5"
  }, [(_vm$selectedTransacti = _vm.selectedTransaction) !== null && _vm$selectedTransacti !== void 0 && _vm$selectedTransacti.source ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "text-bold font-weight-bold w-120"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_source')))]), _c('span', {
    staticClass: "w-120 text-capitalize"
  }, [_vm._v(_vm._s(_vm.selectedTransaction.source))])]) : _vm._e(), _c('div', {
    staticClass: "mt-3 d-flex align-center mb-5"
  }, [(_vm$selectedTransacti2 = _vm.selectedTransaction) !== null && _vm$selectedTransacti2 !== void 0 && _vm$selectedTransacti2.created_at ? _c('span', {
    staticClass: "text-bold font-weight-bold w-120"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_date_created')))]) : _vm._e(), (_vm$selectedTransacti3 = _vm.selectedTransaction) !== null && _vm$selectedTransacti3 !== void 0 && _vm$selectedTransacti3.created_at ? _c('span', {
    staticClass: "text-light"
  }, [_vm._v(_vm._s(_vm.selectedTransaction.created_at))]) : _vm._e(), _c('v-spacer'), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "align-self-center mr-5",
    attrs: {
      "color": "black",
      "size": "24"
    }
  }, [_vm._v("mdi-filter-variant")]), _c('v-select', {
    staticClass: "custom-select elevation-0",
    attrs: {
      "items": _vm.statusFilterOptions,
      "item-disabled": _vm.isItemDisabled,
      "label": "Status",
      "dense": "",
      "solo": "",
      "height": "40"
    },
    model: {
      value: _vm.transactionStatus,
      callback: function ($$v) {
        _vm.transactionStatus = $$v;
      },
      expression: "transactionStatus"
    }
  })], 1)], 1), _c('div', {
    staticClass: "mt-5"
  }, [_c('v-data-table', {
    staticClass: "tbya-transactions-table",
    attrs: {
      "headers": _vm.headers,
      "items-per-page": 5,
      "items": _vm.files,
      "loading": _vm.isLoadingFiles,
      "server-items-length": _vm.totalFiles,
      "footer-props": {
        'items-per-page-text': '',
        'disable-items-per-page': true
      },
      "item-value": "id",
      "loading-text": _vm.$t('amazon_transparency_loading_transactions'),
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.source_file",
      fn: function (_ref) {
        var item = _ref.item;
        return [item !== null && item !== void 0 && item.source_file ? _c('span', {
          staticClass: "view-link text-capitalize text-decoration-underline text-view",
          on: {
            "click": function ($event) {
              return _vm.openLink(item, 'source_file');
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_view')) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.error_log",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [item !== null && item !== void 0 && item.error_log ? _c('span', {
          staticClass: "view-link text-capitalize text-decoration-underline text-view",
          on: {
            "click": function ($event) {
              return _vm.openLink(item, 'error_log');
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_view')) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.status",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          staticClass: "text-capitalize",
          class: _vm.utils.getStatusStyle(item.status.toLowerCase())
        }, [_vm._v(" " + _vm._s(_vm.utils.transformStatusText(item.status)) + " ")])];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-end mt-5 mb-4"
        }, [_c('v-pagination', {
          staticClass: "flex-grow-0",
          attrs: {
            "length": _vm.totalPages,
            "total-visible": 7
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: _vm.options.page,
            callback: function ($$v) {
              _vm.$set(_vm.options, "page", $$v);
            },
            expression: "options.page"
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1)]), _c('v-card-actions', {
    staticClass: "pa-4 px-8 mt-3 pb-6"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "text-uppercase mr-4",
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_close')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }